import React from 'react';
import { Button } from '@mui/material';

const PrimaryButton = ({ children, ...props }) => {
  return (
    <Button
      variant="contained"
      {...props}
      sx={{
        px: 3,
        borderRadius: 2,
        boxShadow: 'none',
        ':hover': { boxShadow: 'none' },
        ...props.sx,
      }}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;


